import {UmpireClub, UmpireTag} from '@tisa-group/models';

export class LoadLinkedEvents {
  static readonly type = '[LinkedEvents] Load Linked Events';

  constructor(readonly tags?: UmpireTag[], readonly club?: UmpireClub) {}
}
